
import './style.scss';

import EventEmitter from 'lib/helpers/EventEmmiter';

export default class E3Listener extends EventEmitter{
  
    constructor() {
        super();

        this._initListener();
    }

    keyDown = (event) => {
        if (event.which === 85 && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            event.stopPropagation();
            this._fireEvent('accessibility', event);
        }
    }

    _initListener(){
        document.addEventListener('keydown', this.keyDown);
    }

    _removeListener(){
        document.removeEventListener('keydown', this.keyDown);
    }

    destroy() {
        this._removeListener();
    }
}
